// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1p6z3","header":"styles_header__1Aw5z","form":"styles_form__1pk2z"};